import { React, ui } from "aaa";
import { ConfirmationDialog } from "../common/ConfirmationDialog";

export const SIdentitySettingsDeleteConfirmationDialog = (props: {
    show: boolean,
    onClose: (deleteDevice?: boolean) => void,
}): any => {
    return (
        <ConfirmationDialog
            show={props.show}
            onClose={props.onClose}
            title={ui.__("sidentitySettings.deleteDevice.confirm.title")}
            message={ui.__("sidentitySettings.deleteDevice.confirm.message")}
            labelOk={ui.__("common.delete")}
        />
    );
};



// WEBPACK FOOTER //
// ./src/components/sIdentitySettings/SidentitySettingsDeleteConfirmationDialog.tsx